import React from 'react';
import { Space, Button, Divider, Flex } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ProductOptionPicker from 'components/pickers/product-option';
import ImagePicker from 'components/pickers/image/ImagePicker';
import AttributeBottomSheet from './AttributeBottomSheet';

const VariantBlockMobile = ({ viewModel }) => {
  const {
    options,
    productOptions,
    sortedVariants,
    filteredOptions,
    hasMultipleVariants,
    loadProductOptions,
    applyAttributeSelections,
    onSelectOptionChange,
    onGroupImageChange,
    onVariantImageChange,
    removeOption,
  } = viewModel;

  const getOptionTitle = (optionId, valueId) => {
    const optDef = productOptions.find((x) => x.id === optionId);
    return optDef?.values?.find((x) => x.id === valueId)?.title || valueId || '-';
  };

  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      {hasMultipleVariants && (
        <>
          {options
            .filter((x) => x.id !== 'default')
            .map((x) => (
              <div key={x.id}>
                <label>{x.title}</label>
                <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                  <div style={{ flexGrow: 1 }}>
                    <ProductOptionPicker value={x.values} id={x.id} onChange={onSelectOptionChange} onAddNewValue={loadProductOptions} />
                  </div>
                  <div>
                    <Button onClick={() => removeOption(x.id)} type='text' icon={<DeleteOutlined />} />
                  </div>
                </div>
              </div>
            ))}
        </>
      )}

      <Flex justify='center'>
        <AttributeBottomSheet
          value={options.filter((x) => x.id !== 'default').map((x) => ({ id: x.id, values: x.values || [] }))}
          productOptions={productOptions}
          onApply={applyAttributeSelections}
          onAttributeCreated={loadProductOptions}
          buttonText='Thêm thuộc tính'
        />
      </Flex>

      {hasMultipleVariants && (() => {
        const opt0 = filteredOptions?.[0];

        if (!opt0) {
          return (sortedVariants || []).map((variant, idx) => (
            <div key={variant?.variant_id || variant?.id || idx} style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 10 }}>
              <Space direction='vertical' size={8} style={{ width: '100%' }}>
                <div>
                  <b>Hình ảnh:</b>
                  <div style={{ marginTop: 6 }}>
                    <ImagePicker value={variant.image} onChange={(e) => onVariantImageChange(e, variant.variant_id)} />
                  </div>
                </div>
              </Space>
            </div>
          ));
        }

        const groups = [];
        const groupMap = {};

        (sortedVariants || []).forEach((variant) => {
          const opt0Value = variant.options?.find((o) => o.id === opt0.id)?.value;
          const key = String(opt0Value || '');
          if (!groupMap[key]) {
            groupMap[key] = {
              key,
              opt0Value,
              title: getOptionTitle(opt0.id, opt0Value),
              image: variant.image || null,
              variants: [],
            };
            groups.push(groupMap[key]);
          }
          if (!groupMap[key].image && variant.image) {
            groupMap[key].image = variant.image;
          }
          groupMap[key].variants.push(variant);
        });

        return groups.map((group) => (
          <div key={group.key} style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 10 }}>
            <Space direction='vertical' size={8} style={{ width: '100%' }}>
              <div style={{ fontWeight: 600 }}>{group.title}</div>
              <div>
                <b>Hình ảnh:</b>
                <div style={{ marginTop: 6 }}>
                  <ImagePicker value={group.image} onChange={(e) => onGroupImageChange(e, opt0.id, group.opt0Value)} />
                </div>
              </div>

              {(group.variants || []).map((variant, index) => (
                <div key={variant?.variant_id || variant?.id || index}>
                  <Space direction='vertical' size={6} style={{ width: '100%' }}>
                    {filteredOptions.slice(1).map((opt, idx) => {
                      const variantOpt = variant.options?.find((o) => o.id === opt.id);
                      const value = getOptionTitle(opt.id, variantOpt?.value);
                      return (
                        <div key={`${variant?.variant_id}-${opt.id}`}>
                          <b>{opt.title || `Thuộc tính ${idx + 2}`}:</b> {value}
                        </div>
                      );
                    })}
                  </Space>
                  {index < group.variants.length - 1 && <Divider style={{ margin: '12px 0' }} />}
                </div>
              ))}
            </Space>
          </div>
        ));
      })()}
    </Space>
  );
};

export default VariantBlockMobile;
